export default __webpack_public_path__ + "static/media/osc_logo.ed5aec50.png";